import { Icon } from '@okam/shared-ui/src'
import { useState } from 'react'
import tw, { css } from 'twin.macro'
import Paragraph from '../Paragraph'
import type { TAccordionProps } from './interface'
import { getHoverStyles, getVariantStyles, getTitleAlignmentStyles, getTextAlignmentStyles } from './styles'

const Accordion = (props: TAccordionProps) => {
  const {
    id,
    color,
    buttonColor,
    hoverColor,
    title,
    ariaLabel,
    variant = 'default',
    alignment = 'left',
    onClick,
    children,
  } = props

  const [isOpen, setIsOpen] = useState(false)

  return (
    <div
      id={`accordion-control-${id}`}
      aria-label={ariaLabel}
      css={[
        tw`!bg-white [border-radius: 32px] text-center p-1.5 focus:outline-none`,
        css`
          color: ${color};
        `,
        getVariantStyles(variant),
        hoverColor && getHoverStyles(hoverColor),
      ]}
      aria-expanded={isOpen}
      aria-controls={`accordion-content-${id}`}
    >
      <button
        tw="grid grid-cols-[3rem_1fr_3rem] overflow-hidden pl-4 sm:pl-8 w-full items-center"
        css={getTitleAlignmentStyles(alignment)}
        onClick={() => {
          setIsOpen(!isOpen)
          onClick?.()
        }}
        type="button"
        id={`accordion-control-${id}`}
        aria-label={ariaLabel}
      >
        {alignment === 'center' && <div />}
        <Paragraph variant="leading" as="p" tw="font-bold mr-8 py-2.5">
          {title}
        </Paragraph>
        <div
          css={[
            css`
              background-color: ${buttonColor};
              ${tw`text-black min-h-12 min-w-12 rounded-full flex items-center justify-center transition duration-500 transform ml-auto aspect-square`},
            `,
            isOpen &&
              css`
                ${tw`-rotate-180 text-white`}
                background-color: ${color};
              `,
          ]}
        >
          <Icon icon="ArrowDown" />
        </div>
      </button>
      <div
        role="region"
        id={`accordion-content-${id}`}
        aria-labelledby={`accordion-control-${id}`}
        css={getTextAlignmentStyles(alignment, isOpen)}
      >
        <section tw="overflow-hidden">{children}</section>
      </div>
    </div>
  )
}

export default Accordion
